﻿var none = 0;
var chest = 1;
var waist = 2;
function WritePrice(price) {
    document.write(GetPrice(price));
}
function GetPrice(price) {
    var retPrice = '';
    var strCurrency = cookies_GetCookie('Currency');
    if (strCurrency == null) strCurrency = 'GBP';
    if (strCurrency != 'GBP') {
        if (strCurrency == 'EUR') retPrice += '€';
        if (strCurrency == 'USD') retPrice += '$';
        if (price == 0) { retPrice += '0.00'; return retPrice; }
        retPrice += (Math.round(Currency.convert((price / 100), "GBP", strCurrency)*100.0)/100.0).toFixed(2);
    } else {
        retPrice += '£';
        if (price == 0) { retPrice += '0.00'; return retPrice; }
        retPrice += (Math.round(price)/100.0).toFixed(2);
    }
    return retPrice;
}
function WriteSize(strTags) {
    var arrTags = strTags.split('|');
    var strDefault = '-';
    for (var i = 0; i < arrTags.length; i++) {
     
        if (arrTags[i].toLowerCase() == 'small' || arrTags[i].toLowerCase() == 'medium' || arrTags[i].toLowerCase() == 'large' || arrTags[i].toLowerCase() == 'extra large')
            strDefault = arrTags[i];

        if (IsNumeric(arrTags[i])) {
            document.write(arrTags[i]);
            return;
        }

    }
    document.write(strDefault);
}
function IsNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function ResizeImageForPreview(strHtml, intWidth) {
    var reImg = new RegExp('<img[^>]+>', 'gi');
    var m = reImg.exec(strHtml);
    if (m == null) {
        return false;
    }

    var strTag = m[0];

    var reWidth = new RegExp('width=\"[^\"]+"', 'g');
    strTag = strTag.replace(reWidth, '');


    var reImgStart = new RegExp('<img', 'g');
    strTag = strTag.replace(reImgStart, '<img width="' + intWidth + '"');
    document.write(strTag);
    return true;
}
function ResizeElement(strEleName, intWidth) {
    var objEle = document.getElementById(strEleName);
    if (objEle == null)
        return;

    objEle.style.width = intWidth + 'px';
}

String.prototype.endsWith = function (str) { return (this.match(str + "$") == str) }
String.prototype.startsWith = function (str) { return (this.match("^" + str) == str) }
String.prototype.trim = function () { return (this.replace(/^[\s\xA0]+/, "").replace(/[\s\xA0]+$/, "")) }